/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {


// $(window).on("load", function () {
//     setTimeout(function() {
//         $(".tabs").show();
//     }, 800);
// });

$(function () {

    // EXTERNAL LINKS NEW WINDOW - DO NO MOVE THIS
    var a = new RegExp('/' + window.location.host + '/');
    var pdf = new RegExp('\.pdf$', 'i');

    $('a[href]').on('click', function(e) {
        if (!a.test(this.href)  || pdf.test(this.href)) {
            window.open(this.href);
            e.preventDefault();
        }
    });

    // UPCOMING CAROUSEL
    $('.upcoming .slides').slick({
        arrows: true,
        dots: true,
        appendArrows: $('.slider .wrapper'),
        appendDots: $('.slider .wrapper'),
        nextArrow: $('.upcoming .next'),
        prevArrow: $('.upcoming .prev'),
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],

        customPaging: function customPaging(slider, i) {
            //var thumb = $(slider.$slides[i]).data();
            i++;
            return '<b>' + i + '</b>';
        }
    });

    $('.upcoming .slides').on('click', '.slick-active + :not(.slick-active)', function() {
        $('.upcoming .slides').slick('slickNext');
    });


    // HOMEPAGE LOGOCLOUD CAROUSEL
    $('.logocloud').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: false,
        cssEase: 'linear',
        dots: false,
        infinite: true,
        slidesToShow: 8,
        speed: 4000,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 7
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 1140,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 1020,
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 560,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });


    // MY WICPA NEWS AND UPDATES
    $(".updates-news .update-list .slides").slick({
        arrows: true,
        dots: true,
        infinite: true,
        nextArrow: $('.updates-news .update-list .next'),
        prevArrow: $('.updates-news .update-list .prev')
    });


    // READ MORE EXPANDERS
    $('body').on('click', '.read-more', function(e){
        $(this).parent().parent().addClass('showing');
        return false;
    });


    // CPE REFINERS EXPANDER
    var $toggleRefiners = $('.refiners button.toggle');
    var $formRefiners = $('.refiners form');


    $toggleRefiners.click(function() {
        var toggleText = $(this).data('toggletext');
        $(this).data('toggletext', $(this).text()).text(toggleText);
        $formRefiners.slideToggle();
    });


    // SUBNAV PANEL
    var $toggle = $('.subnav button.toggle');
    $toggle.show();

    $toggle.on('click', function(){
        var $subnavPane  = $('nav.secondary');
        $subnavPane.slideToggle(200, function() {
            $toggle
                .toggleClass('open')
                .find('b').html($(this).is(':visible') ? 'Hide' : 'Show');
        });
    });



    // TOOLTIP
    $('.tooltip').tooltipster({
        maxWidth: 180
    });


    // TABS
    $('.tabs-nav a').on('click', function (event) {

        var $masthead = $('.masthead');

        if($(this).parent().hasClass('tabs-active')) {
            return;
        } else {
            event.preventDefault();

            $masthead.addClass('open');

            var idx = $(this).parent('li').index();

            $('.tabs-active').removeClass('tabs-active');
            $(this).parent().addClass('tabs-active');
            $('.tabs-panel').hide();
            $('.tabs-panel').eq(idx).show();
        }

    });


    // GOOGLE ANALYTICS EVENTS
    var $gaEvent = $('[data-ga]');

    $gaEvent.on('click', function(event) {

        var href       = $(this).attr('href');
        var gaCategory = $(this).data('ga');
        var firmName   = $(this).closest('.featured-firm').data('featured');

        var payload = {
            hitCallback: adClick
        }  

        if (firmName) {
            payload.eventLabel = firmName;
        } else {
            payload.eventLabel = event.currentTarget.href;
        };

        if (!event.isDefaultPrevented()) {
            setTimeout(adClick, 2000);

            function adClick() {
                window.location.href = href;
            }

            event.preventDefault();
        }

        ga('send', 'event', gaCategory, 'click', payload);
    });


    // SMOOTH SCROLL ANCHOR LINKS
    $('.js-anchor-link').click(function(e){
        e.preventDefault();
        var $target = $($(this).attr('href'));
        if($target.length){
            var scrollTo = $target.offset().top;
            $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
        }
    });


    // FORMS
    // My CPE tracker

    var submitForm = function(){
        this.form.submit();
    };

    $('.form-tracker select').on('change', submitForm);

    $('.form-branch-switch .col-md-auto').hide();
    $('.form-branch-switch select').on('change', function() {
        $('.form-branch-switch .col-md-auto').show();
    });

    // Classifieds
    // Disable Logo if confidential add requested

    var $blindFile = $('body.post-classified [name="blind_file"]');
    var toggleLogo = function(val) {
        if (val) {
            $('.file.logo').fadeTo(250, 1);
            $('.file.logo [name="logo"]').removeAttr('disabled');
        } else {
            $('.file.logo').fadeTo(250, .33);
            $('.file.logo [name="logo"]').attr('disabled', 'disabled');
        }
    }

    toggleLogo(!$blindFile.is(':checked'));

    $blindFile.on('change', function(e) {
        toggleLogo(!$(e.target).is(':checked'));
    });

    // Educational Foundation "Other" Contribution
    var $eduContrib = $('.edu_contribution select');
    var $eduOther   = $('.edu_other');

    $eduContrib.on('change', function(){
        $eduOther.toggle($eduContrib.val().toLowerCase().indexOf('other') >= 0);
    }).triggerHandler('change');



    // Clear form
    var $clearBtn = $('.button.clear');

    $clearBtn.on('click', function(e) {
        e.preventDefault();
        resetForm($(this).closest('form'));
    });

    var resetForm = function($form) {
        $form.find('input:text, input:password, input:file, select, textarea').val('');
        $form.find('input:radio, input:checkbox')
            .removeAttr('checked').removeAttr('selected');
    }

    // Fade in bg color on certain input's associated buttons
    var $act = $('.act');

    $act.on('keyup', function() {
        if ($act.val()!== '') {
            $(this).closest('div').next('div').find('button').removeClass('text');
        } else {
            $(this).closest('div').next('div').find('button').addClass('primary');
        }
    });


    // Disable Submit Payment button in cart after click
    var disableSubmitButton = function() {
        var $submitButton = $('.submit-payment');
        $submitButton.text('Processing. Please wait').css({'cursor': 'default', 'opacity': 0.75});
    }

    var $billingForm = $('form.billing');

    $billingForm.on('submit', disableSubmitButton);

    // MMENU
    var myMenu = $('#nav-primary');
    var $navTrigger = $('nav.triggers a.trigger');
    var $navItem = $('nav.triggers a.item');
    var $win = $(window);
    var $html = $('html');
    var $navPrimaries = $('nav.primary');

    /// initialize mmenu
    myMenu.mmenu({
        navbars: [
            {
                content: [
                    "prev", "close"
                ]
            },
            {
                "position": "top",
                content: [
                    "<a class='logged-out' href='/login'>Login</a>",
                    "<a class='logged-in' href='/logout'>Sign out</a>",
                    "<a class='join' href='/join'>Join</a>",
                    "<a href='/cart'>Cart</a>",
                    "<a href='/search'>Search</a>"
                ]
            }
        ],
        navbar: false,
        offCanvas: {
            blockUI: false,
            zposition: "front"
        }
    });
    /// initialize mmenu API
    var myMenuAPI = myMenu.data( 'mmenu' );

    $('.mm-navbar a.mm-prev').text('Back').removeClass('mm-sronly');
    $('.mm-navbar a.mm-close').text('Close Menu').removeClass('mm-sronly');


    if (window.matchMedia("(min-width: 669px)").matches) {

        // each trigger opens associated mmenu subMenu
        $navTrigger.on('click', function(e){
            var active = $(this);
            var id = active.data('id');
            $navItem.removeClass('active');
            active.css({opacity: '1', color: '#385e9d'});
            active.addClass('active');
            $navItem.not(active).css({opacity: '0.4', color: '#888'});
            e.preventDefault();
            openMMenu();
            setMMenu('#menu-' + id);
        });

        // remove nav triggers’ active class after menu is closed
        myMenuAPI.bind('close:after', function() {
            $navItem.removeClass('active').css({opacity: '1', color: '#385e9d'});
        });

        // close menu when clicking off of it
        $win.on('click', function(event){
            if ($navPrimaries.has(event.target).length == 0 && !$navPrimaries.is(event.target)) {
                closeMMenu();
            }
        });

        // find closest '.mm-panel' to open
        function setMMenu(subMenu) {
            // set to subMenu
            var current = myMenu.find(subMenu);

            // myMenuAPI.setSelected(current.first());
            myMenuAPI.openPanel(current.closest(".mm-panel"));
        }

        /// open mmenu
        function openMMenu() {
            myMenuAPI.open();
        }

        /// close mmenu
        function closeMMenu() {
            myMenuAPI.close();
        }

    }

});




/***/ }),
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
module.exports = __webpack_require__(1);


/***/ })
/******/ ]);
